import ContactIntro from './ContactIntro';
import ContactForm from './ContactForm';

export default function ContactContent() {
  return (
    <div className='space-above'>
      <ContactIntro />
      <ContactForm />
    </div>
  );
}

